<template>
<v-app>
    <v-card flat>

        <div style="height: 0px; display: block; position: absolute; width: 100%;">
            <v-progress-linear color="blue" :indeterminate="true" v-if="loading"></v-progress-linear>
        </div>
        <v-card-title><span class="headline">Виконавці :: {{title}}</span></v-card-title>

        <v-data-table hide-actions disable-initial-sort :headers="filteredHeaders" :items="list" :rows-per-page-items="rowsPerPageItems" rows-per-page-text="на стор." :pagination.sync="pagination" :total-items="totalList" class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr :bgcolor="props.item.statusColor" @click="$router.push('/partners/contacts/card/'+ props.item.contactId)">
                    <td v-for="(col,index) in headers" v-if="headers[index].selected" :class="'text-xs-'+headers[index].align">
                        <div v-if="headers[index].value ==='functions'" v-for="(g, i) in props.item[col.value]">
                            {{ props.item[col.value][i] }}
                        </div>
                        <div v-if="headers[index].value !=='functions'">
                            {{ props.item[col.value] }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-slot:no-data>
                немає даних
            </template>
        </v-data-table>
    </v-card>
</v-app>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {
    props: {
        title: String,
        id: Number
    },
    data() {
        return {
            menu: false,
            message: false,
            error: [],
            totalList: 0,
            list: [],
            loading: true,
            pagination: {},
            rowsPerPageItems: [200],

            headers: [{
                    text: 'Номер',
                    align: 'left',
                    sortable: true,
                    value: 'contactId',
                    selected: true
                },
                {
                    text: 'ПІБ',
                    value: 'fio',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'Функціонал',
                    value: 'functions',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'Телефон sms',
                    value: 'phoneSms',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'E-mail',
                    value: 'email',
                    selected: true,
                    sortable: true,
                },
                {
                    text: 'Логін',
                    value: 'login',
                    selected: true,
                    sortable: true,
                },
            ]
        }
    },

    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true
        }
    },
    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                this.totalList == null
            ) return 0

            return Math.ceil(this.totalList / this.pagination.rowsPerPage)
        },
        filteredHeaders() {
            return this.headers.filter(h => h.selected)
        },
    },
    mounted() {
        const self = this
        this.$root.$on('reloadContactsTable', function () {
            self.getDataFromApi()
        })
    },
    created() {
        if (!localStorage.paginationContacts || localStorage.paginationContacts == '') {
            localStorage.paginationContacts = '{}'
        }
        this.pagination = this.getLocalStorage('paginationContacts')
    },
    methods: {
        getLocalStorage(f) {
            return JSON.parse(localStorage[f])
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        getDataFromApi() {
            this.loading = true
            const {
                sortBy,
                descending,
                page,
                rowsPerPage
            } = this.pagination

            this.setLocalStorage('paginationContacts', this.pagination)

            let items = this.list
            const total = items.length

            if (this.pagination.sortBy) {
                items = items.sort((a, b) => {
                    const sortA = a[sortBy]
                    const sortB = b[sortBy]

                    if (descending) {
                        if (sortA < sortB) return 1
                        if (sortA > sortB) return -1
                        return 0
                    } else {
                        if (sortA < sortB) return -1
                        if (sortA > sortB) return 1
                        return 0
                    }
                })
            }
            if (rowsPerPage > 0) {
                items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
            }
            HTTP.get(`contacts/list`, {
                    params: {
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        page: this.pagination.page,
                        rowsPerPage: this.pagination.rowsPerPage,
                        query: this.query,
                        function: this._function,
                        contractorId: this.id
                    }
                })
                .then(response => {
                    if (response.status == 200 && response.data && response.data.data) {
                        this.list = response.data.data
                        this.totalList = Number(response.data.total)
                    }
                })
                .catch(e => {
                    this.error.push(e)
                })
                .finally(
                    () => {
                        this.loading = false
                    }
                )

        }
    }

}
</script>
